import { Route, Routes } from "react-router-dom";
import LateralCephaloAnaLysis from "./Analyses";
import LAteralChephaloMainPage from "./LAteralChephaloMainPage";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  OfflineCoreServices,
  CallCoreServicesActionWithToken,
} from "../../../appRedux/actions/CoreServicesAction";
import { useEffect } from "react";
import Url from "../../../apiCall/UrlConfig";
import { message } from "antd";
import AnalysesExam from "./AnalysesExam";
import ExamMainPage from "./ExamMainPage";
import AdminLateralCephalo from "./admin";

const RouterLaterlaCephaolo = (props) => {
  useEffect(() => {
    _getUserInfo();
  }, []);

  const _getUserInfo = async () => {
    let url = Url.getuserIfChephalo;

    let res = await props.actions.CallCoreServicesActionWithToken(url, {});

    console.log(res);
    if (res.hasError) {
      message.error(res.message);
      return;
    }
  };

  let userObj = props.coreData[Url.getuserIfChephalo]?.[Url.action]?.data;

  return (
    <div>
      {userObj?.examPassed && (
        <Routes>
          <Route
            path="/analyses/:id/:idAnalyses"
            element={<LateralCephaloAnaLysis />}
          />
          <Route path="/analyses/:id" element={<LateralCephaloAnaLysis />} />
          <Route path="/admin" element={<AdminLateralCephalo />} />
          <Route path="/main" element={<LAteralChephaloMainPage />} />
        </Routes>
      )}

      {userObj?.examPassed === false && (
        <>
          <Routes>
            <Route path="/analyses/:id" element={<AnalysesExam />} />
            <Route path="*" element={<ExamMainPage />} />
          </Routes>
        </>
      )}
    </div>
  );
};

const actionCreators = Object.assign(
  {},
  { CallCoreServicesActionWithToken, OfflineCoreServices }
);
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

const mapStateToProps = (state) => ({
  coreData: state.coreservices.coreData,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RouterLaterlaCephaolo);
